// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Crop_wrapper__2zaCb","Crop--circle":"Crop_Crop--circle__2EZ6M"};